"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogManager_1 = require("../Log/LogManager");
const SessionDefinition_1 = require("./SessionDefinition");
const Session_1 = require("./Session");
const ISessionApplicationService_1 = require("./ISessionApplicationService");
const SessionDto_1 = require("./Protocol/SessionDto");
class SessionApplicationServiceBase {
    constructor(sessionFactory, sessionRepository, cmdHub, evtHub) {
        this._logger = LogManager_1.logManager.GetLogger(this.GetType());
        this._sessionFactory = sessionFactory;
        this._sessionRepo = sessionRepository;
        this._cmdHub = cmdHub;
        this._evtHub = evtHub;
    }
    requestToStartVideoAudioSessionWith(creator, needRecord = false, attendees) {
        const newSession = this._sessionFactory.CreateNewSessionByCreator(SessionDefinition_1.SessionType.Video, creator, needRecord, attendees);
        newSession.Save();
        return newSession.ToSessionTicket();
    }
    async requestToStartVideoAudioSessionWithAsync(creator, needRecord = false, attendees) {
        return this.requestToStartVideoAudioSessionWith(creator, needRecord, attendees);
    }
    requestToStartCreatorVideoAllAudioSessionWith(creator, needRecord = false, attendees) {
        const newSession = this._sessionFactory.CreateNewSessionByCreator(SessionDefinition_1.SessionType.CreatorVideoOnlyAllAudio, creator, needRecord, attendees);
        newSession.Save();
        return newSession.ToSessionTicket();
    }
    requestToStartAudioSessionWith(creator, needRecord = false, attendees) {
        const newSession = this._sessionFactory.CreateNewSessionByCreator(SessionDefinition_1.SessionType.Audio, creator, needRecord, attendees);
        newSession.Save();
        return newSession.ToSessionTicket();
    }
    requestToStartShareScreenSessionWith(creator, needRecord = false, attendees) {
        const newSession = this._sessionFactory.CreateNewSessionByCreator(SessionDefinition_1.SessionType.SharingScreen, creator, needRecord, attendees);
        newSession.Save();
        return newSession.ToSessionTicket();
    }
    requestToStartVideoLiveSessionWith(creator, needRecord = false, attendees) {
        const newSession = this._sessionFactory.CreateNewSessionByCreator(SessionDefinition_1.SessionType.VideoLive, creator, needRecord, attendees);
        newSession.Save();
        return newSession.ToSessionTicket();
    }
    async importSessionAsync(st) {
        const newSession = this._sessionFactory.CreateNewSession(st, []);
        newSession.Save();
        return newSession.ToSessionTicket();
    }
    async querySessionAsync(sessionId) {
        const session = await this._sessionRepo.SessionOfIdAsync(sessionId);
        if (session !== Session_1.Session.INVALID_SESSION) {
            return session.ToSessionDto();
        }
        else
            return SessionDto_1.SessionDto.INVALID_SESSION;
    }
    async startSessionAsync(starter, sessionId, videoContainer = null) {
        const session = await this._sessionRepo.SessionOfIdAsync(sessionId);
        if (session === Session_1.Session.INVALID_SESSION)
            throw new ISessionApplicationService_1.SessionApplicationServiceError(`No session of ${sessionId}`);
        await session.StartAsync(starter, videoContainer);
    }
    async stopSessionAsync(attendee, sessionId) {
        const session = this._sessionRepo.SessionOfId(sessionId);
        if (session === Session_1.Session.INVALID_SESSION)
            throw new ISessionApplicationService_1.SessionApplicationServiceError(`No session of ${sessionId}`);
        await session.StopAsync(attendee);
    }
    async exitSessionAsync(attendee, sessionId) {
        const session = this._sessionRepo.SessionOfId(sessionId);
        if (session === Session_1.Session.INVALID_SESSION)
            throw new ISessionApplicationService_1.SessionApplicationServiceError(`No session of ${sessionId}`);
        await session.ExitAsync(attendee);
    }
    async joinSessionAsync(attendee, sessionId, videoContainer = null) {
        const session = this._sessionRepo.SessionOfId(sessionId);
        if (session === Session_1.Session.INVALID_SESSION)
            throw new ISessionApplicationService_1.SessionApplicationServiceError(`No session of ${sessionId}`);
        await session.JoinAsync(attendee, videoContainer);
    }
    async rejectSessionAsync(attendee, sessionId) {
        const session = this._sessionRepo.SessionOfId(sessionId);
        if (session === Session_1.Session.INVALID_SESSION)
            throw new ISessionApplicationService_1.SessionApplicationServiceError(`No session of ${sessionId}`);
        await session.RejectAsync(attendee);
    }
    querySessionDuration(sessionId) {
        const session = this._sessionRepo.SessionOfId(sessionId);
        return session.Duration;
    }
    queryDurationOfAttendeeSession(sessionId, attendee) {
        const session = this._sessionRepo.SessionOfId(sessionId);
        return session.DurationOfAttendeeSession(attendee);
    }
}
exports.SessionApplicationServiceBase = SessionApplicationServiceBase;
//# sourceMappingURL=SessionApplicationServiceBase.js.map